import { IoChevronBackOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
	const navigate = useNavigate();
	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<button onClick={handleGoBack}>
			<div
				className="flex items-center gap-1 text-grey-50 font-medium text-sm"
				data-test="go-back-button"
			>
				<IoChevronBackOutline />
				<span>Go Back</span>
			</div>
		</button>
	);
};

export default BackButton;
